export const HTTP_RESOURCES_ROOT = "https://regstatic.gohero.es/regency/resources";
